module.exports = __webpack_public_path__ + "img/01.f66855db.jpg";